// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".expansion-text__content[data-v-29d007f5]{overflow:hidden;transition-property:all;transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);transition-duration:150ms;transition-delay:300ms}.expansion-text__border[data-v-29d007f5]{position:absolute;left:0px;right:0px;bottom:0px;height:0.75rem;width:100%;transition:all .2s ease-in-out;background:linear-gradient(180deg,hsla(0,0%,100%,.53),#fff)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
